
import TripManagement from '../views/TripManagement/TripManagementListing';
import UADConfiguration from '../views/configuration/UADConfiguration';
import UADReport from '../views/configuration/UADReport';
import RaiseIssue from '../views/configuration/raiseissue';
import ShipmentSearch from '../views/configuration/shipmentSearch';
import TripSheetPdf from '../views/TripManagement/TripSheetPdf';
import AddExtraCharges from '../views/TripManagement/AddExtraCharges'
import FtcRadShipment from '../views/FtcRadShipment/FtcRadShipmentListing';
import ftcreports from '../views/ftcreports';
import FTCHubCashDeposit from '../views/FTCHubCashDeposit/FTCHubCashDepositListing';
import FTCFinanceCashDeposit from '../views/FTCFinanceCashDeposit';
import makeFTCPayment from '../views/makeFTCPayment';
import SettlementReport from '../views/SettlementReport';
import ShiftShipmentDestinationHub from '../views/ShiftShipmentDestinationHub'
import DamageMPSListing from '../views/DamageMPS/markdamageMPSListing'
import BulkDeliveryConfig from '../views/bulkdelivery';
import flmdashboard from '../views/flmdashboard';
import boxtypeconfig from '../views/boxtypeconfig';
import requestedpickup from '../views/requestedpickupgeneration/requestedpickuplist';
import pickuprequestcsv from '../views/pickuprequestcsv';
import bulkreviewftcdeposit from '../views/bulkreviewftcdeposit'
import reuploadpod from '../views/POD/reuploadpod';
import autoallocation from '../views/Autoallocation/routelist';
import RouteMapping from '../views/Autoallocation/RouteMapping'
import HTDAwbLevelMarking from '../views/htdawblevelmarking'
import FTCPaidCashMemo from '../views/FTCPaidCashMemo';
import marketVehiclerequestList from '../views/marketvehicleflm/marketvehiclelist';
import cargoMarketVehicleRequestFlow from '../views/marketvehicleflm/vehiclerequestapprovalflow';

import podReupload from '../views/TripManagement/CreateTripManagement/closeTrip/podReupload'
import FTCDigitalTransaction from '../views/FTCPaymentMode'

export default [
	{
		path: '/FtcRadShipment',
		name: 'FTC RAD Shipment',
		component: FtcRadShipment,
		title: 'FtcRadShipment',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/ftcreports',
		name: 'FTC Reports',
		component: ftcreports,
		title: 'ftcreports',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/makeftcpayment/:id',
		name: 'makeFTCPayment',
		component: makeFTCPayment,
		title: 'makeftcpayment',
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/FTCFinanceCashDeposit',
		name: 'FTC Finance Cash Deposit',
		component: FTCFinanceCashDeposit,
		title: 'FTCFinanceCashDeposit',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/SettlementReport',
		name: 'Settlement Report',
		component: SettlementReport,
		title: 'SettlementReport',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/FTCHubCashDeposit',
		name: ' FTC Hub Cash Deposit',
		component: FTCHubCashDeposit,
		title: 'FTCHubCashDeposit',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/TripManagement',
		name: 'Trip Management',
		component: TripManagement,
		title: 'TripManagement',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/UADconfiguration',
		name: 'UADConfiguration',
		component: UADConfiguration,
		title: 'UADConfiguration',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/raiseissue/:id',
		name: 'raiseissue',
		component: RaiseIssue,
		title: 'raiseissue',
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/shipmentSearch',
		name: 'shipmentSearch',
		component: ShipmentSearch,
		title: 'shipmentSearch',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/UADReport',
		name: 'UADReport',
		component: UADReport,
		title: 'UADReport',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/TripSheetPdf',
		name: 'Trip Sheet PDF',
		component: TripSheetPdf,
		title: 'TripSheetPdf',
		// meta: {
		//   requiresAuth: true
		// }
	},
	{
		path: '/AddExtraCharges',
		name: 'Add Extra Charges',
		component: AddExtraCharges,
		title: 'AddExtraCharges',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/ShiftShipmentDestinationHub',
		name: 'Shift Shipment Destination Hub',
		component: ShiftShipmentDestinationHub,
		title: 'ShiftShipmentDestinationHub',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/damagempslisting',
		name: 'Damage MPS Listing',
		component: DamageMPSListing,
		title: 'DamageMPSListing',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/bulkdeliveyconfiguration',
		name: 'Configuration',
		component: BulkDeliveryConfig,
		title: 'Configuration',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/flmdashboard',
		name: 'flmdashboard',
		component: flmdashboard,
		title: 'flmdashboard',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/reuploadpod',
		name: 'reuploadpod',
		component: reuploadpod,
		title: 'reuploadpod',
		meta: {
			requiresAuth: false
		}

	},
	{
		path: '/clientboxtypeconfiguration',
		name: 'ClinetBoxTypeConfiguration',
		component: boxtypeconfig,
		title: 'ClientBoxTypeConfiguration',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/requestedpickup',
		name: 'requestedpickup',
		component: requestedpickup,
		title: 'requestedpickup',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/pickuprequestcsv',
		name: 'pickuprequestcsv',
		component: pickuprequestcsv,
		title: 'pickuprequestcsv',
		meta: {
			requiresAuth: false
		}
	},
	{
		path: '/route',
		name: 'Autoallocation',
		component: autoallocation,
		title: 'Autoallocation',
		meta: {
			requiresAuth: true
		}

	},
	{
		path: '/RouteMapping',
		name: 'RouteMapping',
		component: RouteMapping,
		title: 'RouteMapping',
		meta: {
			requiresAuth: true
		}

	},
	{
		path: '/htdawblevelmarking',
		name: 'HTDAwbLevelMarking',
		component: HTDAwbLevelMarking,
		title: 'HTDAwbLevelMarking',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/FTCPaidCashMemo',
		name: 'FTCPaidCashMemo',
		component: FTCPaidCashMemo,
		title: 'FTCPaidCashMemo',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/poduploadpendency',
		name: 'podReupload',
		component: podReupload,
		title: 'podReupload',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/marketVehiclerequestList',
		name: 'marketVehiclerequestList',
		component: marketVehiclerequestList,
		title: 'marketVehicleList',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/marketvehicleapprovalflow',
		name: 'cargoMarketVehicleRequestFlow',
		component: cargoMarketVehicleRequestFlow,
		title: 'cargoMarketVehicleRequestFlow',
		meta: {
			requiresAuth: true
		}
	},{
		path: '/bulkreviewftcdeposit',
		name: 'bulkreviewftcdeposit',
		component: bulkreviewftcdeposit,
		title: 'bulkreviewftcdeposit',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/ftcdigitaltransactions',
		name: 'ftcdigitaltransactions',
		component: FTCDigitalTransaction,
		title: 'ftcdigitaltransactions',
		meta: {
			requiresAuth: true
		}
	}	
]



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/router/index.js